var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bolita 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.111486%",
    y1: "35.882568%",
    x2: "42.4525333%",
    y2: "83.7889099%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D7D6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-2",
    cx: 18,
    cy: 18,
    r: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desarrollo-Juego",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 6,
    transform: "translate(-795, -29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bolita-2",
    transform: "translate(795, 29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Aa",
    transform: "translate(7.912, 12.79)",
    fill: "#84BD00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.35,9.828 L9.884,9.828 L6.328,0 L3.556,0 L0,9.828 L2.506,9.828 L3.094,8.092 L6.762,8.092 L7.35,9.828 Z M6.146,6.244 L3.724,6.244 L4.928,2.646 L6.146,6.244 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.486,5.908 C10.486,8.372 12.012,9.94 13.916,9.94 C15.078,9.94 15.904,9.408 16.338,8.722 L16.338,9.828 L18.732,9.828 L18.732,2.016 L16.338,2.016 L16.338,3.122 C15.918,2.436 15.092,1.904 13.93,1.904 C12.012,1.904 10.486,3.444 10.486,5.908 Z M16.338,5.922 C16.338,7.168 15.54,7.854 14.63,7.854 C13.734,7.854 12.922,7.154 12.922,5.908 C12.922,4.662 13.734,3.99 14.63,3.99 C15.54,3.99 16.338,4.676 16.338,5.922 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpt2);
export default __webpack_public_path__ + "static/media/opt2.d089ed1b0d4532ef73d0c0c632ee0820.svg";
export { ForwardRef as ReactComponent };